export default __webpack_public_path__ + "static/media/gallery-wip-crystal-holder_03.846411e7.jpg";